import { render, staticRenderFns } from "./WaiterProgressHistoryEdit.vue?vue&type=template&id=7257efd4&scoped=true&lang=pug"
import script from "./WaiterProgressHistoryEdit.vue?vue&type=script&lang=ts"
export * from "./WaiterProgressHistoryEdit.vue?vue&type=script&lang=ts"
import style0 from "./WaiterProgressHistoryEdit.vue?vue&type=style&index=0&id=7257efd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7257efd4",
  null
  
)

export default component.exports